
import React from 'react'
import { AgencyHierachyData } from '../../Models/tableDetailsModel';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import styles from '../escalatedTable/escalatedTable.module.css'
import HierachyTableRow from './hierachyTableRow';
import { useAgencyInfo } from '../../Context/agencyContext';
import { HiddenColumnsForAgencyHierarchyHeaders } from "../../constants/ColumnToExcludeInAgencyHierarchy";

interface IAgencyHierachyProps {
    hierachyHeaderName: (keyof AgencyHierachyData)[] | null;
}

const staticRowWith = [300, 150];

function getLeft(index: number) {
    const sum = staticRowWith.slice(0, index).reduce((acc, val) => acc + val, 0);
    return sum;
}

export const AgencyHierachyTable = (props: IAgencyHierachyProps) => {
    const { hierachyHeaderName } = props
    const { agencyHierachyResponse } = useAgencyInfo();

    if (!agencyHierachyResponse || agencyHierachyResponse?.agentHierarchyData?.length === 0) {
        return (
            <p className={styles.noData}>
                No Data Available
            </p>
        )
    }

    return (
        <TableContainer
            sx={{
                height: '100%',
                width: '100%',
                overflow: 'auto',
                display: 'block',
            }}
        >
            <Table
                aria-label="agency hierarchy table"
                className={styles.escalatedTable}
                stickyHeader
                sx={{ minWidth: 'max-content', width: '100%' }}
            >
                <TableHead className={styles.escalatedTableHead}>
                    <TableRow className={styles.escalatedTableHeaderRow}>
                        {hierachyHeaderName
                            ?.filter((column) => {
                                const header = column as string
                                return !HiddenColumnsForAgencyHierarchyHeaders.includes(header)
                                    && header !== "Children"
                                    && header !== "Open Child"
                            })
                            ?.map((header, index: number) => (
                                <TableCell
                                    key={header as string}
                                    align="left"
                                    sx={index < 2 ?
                                        {
                                            left: getLeft(index),
                                            zIndex: 3,
                                            position: 'sticky',
                                            top: 0,
                                            backgroundColor: '#F8F9FA',
                                            minWidth: staticRowWith[index],
                                            maxWidth: staticRowWith[index],
                                            borderRight: index === 1 ? '1px solid #e0e0e0' : 'none',
                                        } : {
                                            minWidth: "300px",
                                            backgroundColor: '#F8F9FA !important',
                                            zIndex: 2,
                                            position: 'sticky',
                                            top: 0,
                                        }
                                    }
                                >
                                    {header}
                                </TableCell>
                            ))}
                    </TableRow>
                </TableHead>
                <TableBody className={styles.escalatedTableBody}>
                    {agencyHierachyResponse?.agentHierarchyData.map((row: AgencyHierachyData, i: number) => (
                        <HierachyTableRow
                            key={row.userId}
                            row={row}
                            i={i}
                            childIndex={null}
                            shiftLeft={0}
                        />
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    )
}
